module.exports = __webpack_public_path__ + "media/src/ui/icons/MOV-f85c871420d3e9ecd0ad170b11006b4d.svg";